import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import PasswordField from '../../fields/PasswordField/PasswordField';
import TextField from '../../fields/TextField/TextField';
import { EXAMPLE_FORM } from '../../constants/formNames';
import submitExampleForm from '../../submit/submitExampleForm';
import validateExampleForm from '../../validate/validateExampleForm';
import SelectField from '../../fields/SelectField/SelectField';
import Button from '../../../../../elements-buttons/Button';
import { defineMessages, injectIntl, intlShape, FormattedMessage } from 'react-intl';


const ExampleForm = ({ intl, handleSubmit }) => {
  const translationMessages = defineMessages({
    errorMsg: {
      id: 'hosting.example_form.error_message',
      defaultMessage: 'Please enter a valid user name'
    },
    optionsOne: {
      id: 'hosting.example_form.value_one',
      defaultMessage: 'This is value 1'
    },
    optionsTwo: {
      id: 'hosting.example_form.value_two',
      defaultMessage: 'This is value 2'
    }
  });

  const options = [
    { value: 'value1', label: intl.formatMessage(translationMessages.optionsOne) },
    { value: 'value2', label: intl.formatMessage(translationMessages.optionsTwo) }
  ];

  return (
    <form className="ExampleForm style-2" onSubmit={handleSubmit(submitExampleForm)}>
      <div className="flex column">
        <h1>
          <FormattedMessage
            id="hosting.example_form.form_heading"
            defaultMessage="Example Form"
          />
        </h1>

        <div>
          <FormattedMessage
            id="hosting.example_form.username_label"
            defaultMessage="User Name"
          />
        </div>

        <Field
          component={TextField}
          name="username"
          errorMessage="Please enter a valid user name"
        />

        <div>
          <FormattedMessage
            id="hosting.example_form.password_label"
            defaultMessage="Password"
          />
        </div>

        <Field
          component={PasswordField}
          name="password"
          showPasswordRequirements
        />

        <div>
          <FormattedMessage
            id="hosting.example_form.select_field_label"
            defaultMessage="Select Field"
          />
        </div>

        <Field
          className="flex margin-lg-bottom"
          inputClassName="flex-grow"
          component={SelectField}
          options={options}
          name="shareState"
          errorMessage={intl.formatMessage(translationMessages.errorMessage)}
        />


        <hr />

        <Button className="btn btn-large btn-primary flex center">
          <FormattedMessage
            id="hosting.example_form.button_text"
            defaultMessage="Save"
          />
        </Button>
      </div>
    </form>
  );
};

ExampleForm.propTypes = {
  handleSubmit: PropTypes.func,
  intl: intlShape
};

const config = {
  form: EXAMPLE_FORM,
  validate: validateExampleForm
};

export default reduxForm(config)(injectIntl(ExampleForm));
